/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceReference } from './SourceReference';
import {
    SourceReferenceFromJSON,
    SourceReferenceFromJSONTyped,
    SourceReferenceToJSON,
    SourceReferenceToJSONTyped,
} from './SourceReference';

/**
 * 
 * @export
 * @interface SplitRequest
 */
export interface SplitRequest {
    /**
     * 
     * @type {Array<Array<SourceReference>>}
     * @memberof SplitRequest
     */
    groupedSources?: Array<Array<SourceReference>>;
    /**
     * 
     * @type {string}
     * @memberof SplitRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the SplitRequest interface.
 */
export function instanceOfSplitRequest(value: object): value is SplitRequest {
    return true;
}

export function SplitRequestFromJSON(json: any): SplitRequest {
    return SplitRequestFromJSONTyped(json, false);
}

export function SplitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupedSources': json['groupedSources'] == null ? undefined : json['groupedSources'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function SplitRequestToJSON(json: any): SplitRequest {
    return SplitRequestToJSONTyped(json, false);
}

export function SplitRequestToJSONTyped(value?: SplitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupedSources': value['groupedSources'],
        'reason': value['reason'],
    };
}

